import { Blockchain } from 'src/utils/types';
import icAvalanche from 'assets/svg/ic_avalanche_chain.svg';
import icEthereum from 'assets/svg/ic_ethereum_chain.svg';
import icCelo from 'assets/svg/ic_celo_chain.svg';
import icBinance from 'assets/svg/ic_binance_chain.svg';
import icSolana from 'assets/svg/ic_solana_chain.svg';
import icPolygon from 'assets/svg/ic_polygon_chain.svg';
import icFantom from 'assets/svg/ic_fantom_chain.svg';
export const chainIconMap = {
  [Blockchain.AVALANCHE]: icAvalanche,
  [Blockchain.BINANCE]: icBinance,
  [Blockchain.CELO]: icCelo,
  [Blockchain.ETHEREUM]: icEthereum,
  [Blockchain.POLYGON]: icPolygon,
  [Blockchain.SOLANA]: icSolana,
  [Blockchain.FANTOM]: icFantom
};